import React from 'react';
import { Loader2 } from 'lucide-react';

interface AudioExtractionModalProps {
  fileName: string;
  progress: number;
  statusMessage: string;
}

export const AudioExtractionModal: React.FC<AudioExtractionModalProps> = ({ fileName, progress, statusMessage }) => {
  return (
    <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center p-4" aria-modal="true" role="dialog">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md flex flex-col items-center p-8 text-black">
        <Loader2 className="w-10 h-10 animate-spin text-gray-500 mb-4" />
        <h2 className="text-xl font-semibold mb-2" id="modal-title">Analyse en cours...</h2>
        <p className="text-sm text-gray-600 mb-6 text-center min-h-[40px] flex items-center justify-center">
          {statusMessage}
        </p>
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div
            className="bg-black h-2.5 rounded-full transition-all duration-200"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <p className="text-lg font-bold mt-3" aria-live="polite">{progress}%</p>
        <p className="text-xs text-gray-500 mt-4 text-center">
          Fichier : <span className="font-medium">{fileName}</span>
        </p>
      </div>
    </div>
  );
};
